$(".new-swiper").each(function(item){
    let $this = $(this);
    $(this)[0].swiper.on('slideChange', function () {
        if($this.find(`.new-swiper-slide[data-index="${this.activeIndex}"]`).hasClass("new-swiper-slide-video")){
            $this.find(`.new-swiper-slide[data-index="${this.activeIndex}"]`).find(".new-swiper-video").trigger("play");
        }
        else{
            pauseAllVid();
        }
    });
})

function pauseAllVid(){
    if($(".new-swiper-video").length > 0){
        $(".new-swiper-video").each(function(){
            $(this).trigger("pause");
        });
    }
}

$(function(){
    if($(".new-main-variants-option-input").length > 0){
        let val = $(".new-main-variants-option-input:checked").val();
        if($(`.new-model-options-wrapper[data-model="${val}"]`).length > 0){
            if($(".new-main-variants-option-input:checked").attr("data-hide-model-option") == 'true'){
                $(`.new-model-options-wrapper[data-model="${val}"]`).addClass("active hide-model-option");
            }
            else{
                $(`.new-model-options-wrapper[data-model="${val}"]`).addClass("active");
            }
        }
    }
    // if($(".new-option-swatch-inp").length > 0){
    //     if($(".new-product-options-wrapper.active .new-product-options.new-hide-option-for-prod select.new-product-option-input").length > 0){
    //         let swval = $(".new-product-options-wrapper.active .new-product-options.new-hide-option-for-prod select.new-product-option-input").val().trim();
    //         if($(".new-option-swatch-inp").attr("data-val-uncheck").trim() == swval){
    //             $(".new-option-swatch-inp").prop("checked", false);
    //         }
    //         else if($(".new-option-swatch-inp").attr("data-val-check").trim() == swval){
    //             $(".new-option-swatch-inp").prop("checked", true);
    //         }
    //     }
    // }
})

$(document).on("change", ".new-main-variants-option-input", function(){
    pauseAllVid();
    let val = $(this).val();
    if($(this).attr("data-redirect-link") != "none"){
        $(".new-product-options-wrapper, .new-model-options-wrapper").removeClass("active");
        location.href = $(this).attr("data-redirect-link");
        return;
    }
    if($(`.new-desc-variant[data-val="${val}"]`).length > 0){
        $(`.new-desc-variant`).removeClass("active");
        $(`.new-desc-variant[data-val="${val}"]`).addClass("active");
    }
    if($(`.new-accordion-item[data-id="${$(this).attr("data-id")}"]`).length > 0){
        $(".new-accordion-item").removeClass("new-active");
        $(`.new-accordion-item[data-id="${$(this).attr("data-id")}"]`).addClass("new-active");
    }
    $(".new-model-options-wrapper").removeClass("active");
    $(".new-model-options-wrapper").removeClass("hide-model-option");
    if($(`.new-model-options-wrapper[data-model="${val}"]`).length > 0){
        if($(this).attr("data-hide-model-option") == 'true'){
            $(`.new-model-options-wrapper[data-model="${val}"]`).addClass("active hide-model-option");
        }
        else{
            $(`.new-model-options-wrapper[data-model="${val}"]`).addClass("active");
        }
    }

    if($(".new-tissot-wrapper").length > 0){
        $(".new-tissot-wrapper").removeClass("active");
        $(".new-tissot-smooth ,.new-tissot-fluted").removeClass("active");
        setTimeout(function(){
            let tissotVid = $(`.new-product-options-wrapper.active .new-product-master-li.active`).attr("data-id");
            if($(`.new-tissot-wrapper[data-vid="${tissotVid}"]`).length > 0){
                $(`.new-tissot-wrapper[data-vid="${tissotVid}"]`).addClass("active");
                if($(".new-option-swatch-inp").length > 0){
                    if($(".new-option-swatch-inp").is(":checked")){
                        $(`.new-tissot-wrapper[data-vid="${tissotVid}"]`).find(".new-tissot-fluted").addClass("active");
                    }
                    else{
                        $(`.new-tissot-wrapper[data-vid="${tissotVid}"]`).find(".new-tissot-smooth").addClass("active");
                    }
                }
            }
        }, 100)
    }

    let pid = $(".new-model-options-wrapper.active .new-model-option-select option:selected").val();
    let desc = $(`.new-model-options-wrapper.active`).find(`.new-p-desc[data-id="${pid}"]`).html();
    $(".new-p-desc-wrapper").removeClass("active");
    if($(".new-p-desc-wrapper").length > 0){
        $(".new-p-desc-wrapper").html(desc);
    }
    $(".new-product-options-wrapper").removeClass("active");
    if($(`.new-product-options-wrapper[data-id="${pid}"]`).length > 0){
        $(`.new-product-options-wrapper[data-id="${pid}"]`).addClass("active");
    }

    if($(".new-prodcut-reviews-item").length > 0){
        $(".new-prodcut-reviews-item").removeClass("active");
        if($(`.new-prodcut-reviews-item[data-id="${pid}"]`).length > 0){
            $(`.new-prodcut-reviews-item[data-id="${pid}"]`).addClass("active");
        }
    }

    $(".new-swiper-coll-wrapper").removeClass("active");
    if($(`.new-swiper-coll-wrapper[data-model="${val}"]`).length > 0){
        $(`.new-swiper-coll-wrapper[data-model="${val}"]`).addClass("active");
    }

    $(".new-swiper-wrapper").removeClass("active");
    if($(`.new-swiper-wrapper[data-id="${pid}"]`).length > 0){
        $(`.new-swiper-wrapper[data-id="${pid}"]`).addClass("active");
    }

    updateVariants(false);

    // if($(".new-option-swatch-inp").length > 0){
    //     if($(".new-product-options-wrapper.active .new-product-options.new-hide-option-for-prod select.new-product-option-input").length > 0){
    //         let swval = $(".new-product-options-wrapper.active .new-product-options.new-hide-option-for-prod select.new-product-option-input").val().trim();
    //         if($(".new-option-swatch-inp").attr("data-val-uncheck").trim() == swval){
    //             $(".new-option-swatch-inp").prop("checked", false);
    //         }
    //         else if($(".new-option-swatch-inp").attr("data-val-check").trim() == swval){
    //             $(".new-option-swatch-inp").prop("checked", true);
    //         }
    //     }
    // }
})
$(document).on("change", ".new-model-option-select", function(){
    pauseAllVid();
    let pid = $(this).val();
    $(".new-product-options-wrapper").removeClass("active");
    let desc = $(`.new-model-options-wrapper.active`).find(`.new-p-desc[data-id="${pid}"]`).html();
    $(".new-p-desc-wrapper").removeClass("active");
    if($(".new-p-desc-wrapper").length > 0){
        $(".new-p-desc-wrapper").html(desc);
    }
    if($(`.new-product-options-wrapper[data-id="${pid}"]`).length > 0){
        $(`.new-product-options-wrapper[data-id="${pid}"]`).addClass("active");
    }

    if($(".new-prodcut-reviews-item").length > 0){
        $(".new-prodcut-reviews-item").removeClass("active");
        if($(`.new-prodcut-reviews-item[data-id="${pid}"]`).length > 0){
            $(`.new-prodcut-reviews-item[data-id="${pid}"]`).addClass("active");
        }
    }

    $(".new-swiper-wrapper").removeClass("active");
    if($(`.new-swiper-wrapper[data-id="${pid}"]`).length > 0){
        $(`.new-swiper-wrapper[data-id="${pid}"]`).addClass("active");
    }

    updateVariants(false);
})
$(document).on("change", ".new-product-option-input", function(){
    pauseAllVid();
    let comb = '';
    $(this).parents(".new-product-options-inner-wrapper").find(".new-product-option-input").each(function(){
        if($(this).hasClass("new-product-option-select")){
            comb += $(this).val() + ' / ';
        }
        else{
            if($(this).is(":checked")){
                comb += $(this).val() + ' / ';
            }
        }
    })
    comb = comb.substring(0, comb.length - 2).trim();
    if($(this).parents(".new-product-options-wrapper").find(`.new-product-master-li[data-title="${comb}"]`).length > 0){
        $(this).parents(".new-product-options-wrapper").find(`.new-product-master-li`).removeClass("active");
        $(this).parents(".new-product-options-wrapper").find(`.new-product-master-li[data-title="${comb}"]`).addClass("active");
        let master = $(this).parents(".new-product-options-wrapper").find(`.new-product-master-li[data-title="${comb}"]`);
        $(".new-atc-btn").attr("data-id", master.attr("data-id"));
        $(".new-atc-btn").attr("data-pid", master.attr("data-pid"));
        $(".new-atc-btn").attr("data-product", master.attr("data-product"));
        
        if($(".new-tissot-wrapper").length > 0){
            $(".new-tissot-wrapper").removeClass("active");
            if($(`.new-tissot-wrapper[data-vid="${master.attr("data-id")}"]`).length > 0){
                $(`.new-tissot-wrapper[data-vid="${master.attr("data-id")}"]`).addClass("active");
                $(".new-tissot-smooth ,.new-tissot-fluted").removeClass("active");
                if($(".new-option-swatch-inp").length > 0){
                    if($(".new-option-swatch-inp").is(":checked")){
                        $(`.new-tissot-wrapper[data-vid="${master.attr("data-id")}"]`).find(".new-tissot-fluted").addClass("active");
                    }
                    else{
                        $(`.new-tissot-wrapper[data-vid="${master.attr("data-id")}"]`).find(".new-tissot-smooth").addClass("active");
                    }
                }
            }
        }
        
        let $stockBlock = $(".custom-stock");
        let policy = master.attr("data-policy");
        let isPreorder = master.attr("data-preorder") === "true";

        $(".new-atc-btn").removeClass("unavailable").removeClass("new-preorder");
        if(isPreorder) {
            $(".new-atc-btn").removeClass("unavailable").addClass("new-preorder");
        }
        
        if(master.attr("data-sold") == "sold"){
            $(".new-atc-btn").removeClass("unavailable").addClass("sold");
            
           
            if (isPreorder || policy === 'continue') {
                $stockBlock.hide();
            } else {
                $stockBlock.show();
                if($stockBlock.length > 0 && $(".stock-text").length > 0){
                    $stockBlock.removeClass("in-stock").addClass("out-stock");
                    $(".stock-text").text("OUT OF STOCK");
                }
            }
        }
        else{
            $(".new-atc-btn").removeClass("sold").removeClass("unavailable");
            $(".new-atc-btn").html(master.attr("data-text"));
            
           
            if (isPreorder || policy === 'continue') {
                $stockBlock.hide();
            } else {
                $stockBlock.show();
                if($stockBlock.length > 0 && $(".stock-text").length > 0){
                    $stockBlock.removeClass("out-stock").addClass("in-stock");
                    $(".stock-text").html("&nbsp;&nbsp;&nbsp;IN STOCK");
                }
            }
        }
       

        let img = master.attr("data-img");
        if(img != "none"){
            let index = parseInt($(`.new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper .new-swiper-img[data-img="${img}"]`).attr("data-index"));
            $(".new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper")[0].swiper.slideTo(index);
        }
        else{
            $(".new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper")[0].swiper.slideTo(0);
        }
    }
    else{
        $(".new-atc-btn").removeClass("sold");
        $(".new-atc-btn").addClass("unavailable");
    }
});

$(function(){
    updateVariants(false);
})

function updateVariants(change_image=true){
    let comb = '';
    $(".new-product-options-wrapper.active").find(".new-product-option-input").each(function(){
        if($(this).hasClass("new-product-option-select")){
            comb += $(this).val() + ' / ';
        }
        else{
            if($(this).is(":checked")){
                comb += $(this).val() + ' / ';
            }
        }
    })
    comb = comb.substring(0, comb.length - 2).trim();
    if($(".new-product-options-wrapper.active").find(`.new-product-master-li[data-title="${comb}"]`).length > 0){
        $(".new-product-options-wrapper.active").find(`.new-product-master-li`).removeClass("active");
        $(".new-product-options-wrapper.active").find(`.new-product-master-li[data-title="${comb}"]`).addClass("active");
        let master = $(".new-product-options-wrapper.active").find(`.new-product-master-li[data-title="${comb}"]`);
        $(".new-atc-btn").attr("data-id", master.attr("data-id"));
        $(".new-atc-btn").attr("data-pid", master.attr("data-pid"));
        $(".new-atc-btn").attr("data-product", master.attr("data-product"));
        
       
        let $stockBlock = $(".custom-stock");
        let policy = master.attr("data-policy");
        let isPreorder = master.attr("data-preorder") === "true";

        $(".new-atc-btn").removeClass("unavailable").removeClass("new-preorder");
        if(isPreorder) {
            $(".new-atc-btn").removeClass("unavailable").addClass("new-preorder");
        }
        

        if(master.attr("data-sold") == "sold"){
            $(".new-atc-btn").removeClass("unavailable").addClass("sold");
            
           
            if (isPreorder || policy === 'continue') {
                
                $stockBlock.hide();
            } else {
               
                $stockBlock.show();
                if($stockBlock.length > 0 && $(".stock-text").length > 0){
                    $stockBlock.removeClass("in-stock").addClass("out-stock");
                    $(".stock-text").text("OUT OF STOCK");
                }
            }
        }
        else{
            $(".new-atc-btn").removeClass("sold").removeClass("unavailable");
            $(".new-atc-btn").html(master.attr("data-text"));

          
            if (isPreorder || policy === 'continue') {
                
                $stockBlock.hide();
            } else {
                
                $stockBlock.show();
                if($stockBlock.length > 0 && $(".stock-text").length > 0){
                    $stockBlock.removeClass("out-stock").addClass("in-stock");
                    $(".stock-text").html("&nbsp;&nbsp;&nbsp;IN STOCK");
                }
            }
        }

        let firstVideo = false;
        if(!change_image){
            if($(`.new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper .new-swiper-slide:first-child`).hasClass("new-swiper-slide-video")){
                firstVideo = true;
            }
        }
        if(firstVideo){
            $(".new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper")[0].swiper.slideTo(0);
            setTimeout(function(){
                $(`.new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper .new-swiper-slide:first-child .new-swiper-video`).trigger("play");
            }, 200);
        }
        else{
            let img = master.attr("data-img");
            if(img != "none"){
                let index = parseInt($(`.new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper .new-swiper-img[data-img="${img}"]`).attr("data-index"));
                $(".new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper")[0].swiper.slideTo(index);
            }
            else{
                $(".new-swiper-coll-wrapper.active .new-swiper-wrapper.active .new-swiper")[0].swiper.slideTo(0);
            }
        }
    }
    else{
        $(".new-atc-btn").removeClass("sold");
        $(".new-atc-btn").addClass("unavailable");
        
        $(".custom-stock").hide(); 
    }
}

$(document).on("click", ".new-atc-btn:not(.sold), .new-atc-btn-default:not(.sold)", function(){
    $(`.new-preorder-popup`).removeClass("active");
    if($(this).hasClass("new-preorder")){
        let pid = $(this).attr("data-pid");
        if($(`.new-preorder-popup[data-pid="${pid}"]`).length > 0){
            $(`.new-preorder-popup[data-pid="${pid}"]`).addClass("active");
        }
        else{
            $(`.new-preorder-popup[data-pid="default"]`).addClass("active");
        }
        return;
    }
  let arr = [];
  arr.push({ 'id': $(this).attr("data-id"), 'quantity': 1 });
  _add_cart(arr, $(this), true);
})

$(document).on("click", ".new-preorder-popup, .new-preorder-popup-close", function(){
    $(`.new-preorder-popup`).removeClass("active");
});

$(document).on("click", ".new-preorder-popup-content", function(e){
    e.stopPropagation();
});

$(document).on("click", ".new-preorder-popup-accept", function(){
    if($(this).hasClass("new-preorder-popup-accept--custom")){
        $(`.new-preorder-popup`).removeClass("active");
        $(this).parents("section").find(".bzc-atc-btn").removeClass("new-preorder");
        $(this).parents("section").find(".bzc-atc-btn").trigger("click");
    }
    else{
        $(this).parents("section").find(".new-atc-btn, .new-atc-btn-default").removeClass("new-preorder");
        $(this).parents("section").find(".new-atc-btn, .new-atc-btn-default").trigger("click");
    }
});

$(document).on("click", ".new-atc-btn.sold, .new-atc-btn-default.sold", function(){
    let url = $(this).attr('data-product');
    let variantId = Number($(this).attr("data-id"));
    let $this = $(this);
    $this.addClass("active");
    fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
        $this.removeClass("active");
      }
      return response.json(); 
    })
    .then(data => {
      window._RestockRocket.openModal(data, variantId);
      $this.removeClass("active");
    })
    .catch(error => {
      console.error('Fetch error:', error);
      $this.removeClass("active");
    });
})


function _add_cart(productsArr, $this, open=false){
    $this.addClass("active");
    let formData = {
      'items': productsArr,
      sections: "cart-drawer,cart-icon-bubble"
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if(res.status){
        console.log(res);
      }
      else{
        const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
        const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
        $("cart-drawer.drawer").removeClass("is-empty");
        $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
        $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
        if(open){
          document.querySelector("#cart-icon-bubble").dispatchEvent(new Event('click'));
          $(".cart-count-bubble").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      $this.removeClass("active");
    });
  }

  $(function(){
    $(".new-main-variants-options .new-main-variants-option-input:first-child").trigger("click");

    let pid = $(".new-model-options-wrapper.active .new-model-option-select option:selected").val();
    let desc = $(`.new-model-options-wrapper.active`).find(`.new-p-desc[data-id="${pid}"]`).html();
    $(".new-p-desc-wrapper").removeClass("active");
    if($(".new-p-desc-wrapper").length > 0){
        $(".new-p-desc-wrapper").html(desc);
    }
  })

  $(document).on("click", ".accordion-header", function(){
    if($(this).parent().hasClass("new-accordion-item")){
        $('.new-accordion-item .accordion-header').toggleClass("custom-acc-active");
        $('.new-accordion-item .accordion-body').slideToggle(300);
    }
    else{
        $(this).toggleClass("custom-acc-active");
        $(this).next(".accordion-body").slideToggle(300);
    }
  })
  $(".new-p-desc-read-more").click(function(){
    $(this).prev(".new-p-desc-wrapper").toggleClass("active");
  })
  $(".new-p-desc-wrapper").click(function(){
    $(this).toggleClass("active");
  })

class SoldTodayPill extends HTMLElement {
  connectedCallback() {
    this.min = parseInt(this.getAttribute('min'));
    this.max = parseInt(this.getAttribute('max'));
    this.span = this.querySelector(".new-pill-number");
    this.productId = this.getAttribute('product-id') || "default";
    this.updateValue();
  }
  updateValue() {
    const key = `sold_today_value_${this.productId}`;
    const timestampKey = `sold_today_timestamp_${this.productId}`;
    const now = Date.now();
    const twelveHours = 12 * 60 * 60 * 1000;
    const savedNumber = localStorage.getItem(key);
    const savedTimestamp = localStorage.getItem(timestampKey);
    let newNumber;
    if (savedNumber && savedTimestamp && (now - savedTimestamp < twelveHours)) {
      newNumber = savedNumber;
    } else {
      newNumber = this.generateRandom(this.min, this.max);
      localStorage.setItem(key, newNumber);
      localStorage.setItem(timestampKey, now.toString());
    }
    this.span.textContent = newNumber;
  }
  generateRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
customElements.define("sold-today-pill", SoldTodayPill);

const FILTER_OPTIONS = ["finish", "steel grade"];
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".new-product-options-wrapper").forEach((wrapper) => {
    const productId = wrapper.getAttribute("data-id");
    if (!productId) return;
    const variants = [];
    wrapper.querySelectorAll(".new-product-master-li").forEach((li) => {
      const title = li.getAttribute("data-title") || "";
      const options = title.split(" / ");
      const available = li.getAttribute("data-sold") === "available";
      variants.push({ options, available });
    });
    const optionBlocks = wrapper.querySelectorAll("[data-option-block]");
    function getSelection() {
      const selection = {};
      wrapper.querySelectorAll(".new-product-option-input").forEach((input) => {
        const index = parseInt(input.getAttribute("data-index"), 10);
        if (input.tagName === "SELECT") {
          selection[index] = input.value;
        } else if (input.type === "radio" && input.checked) {
          selection[index] = input.value;
        }
      });
      return selection;
    }
    function isValid(optionIndex, candidateValue, selection) {
      return variants.some((variant) => {
        if (!variant.available) return false;
        return variant.options.every((opt, idx) => {
          if (idx === optionIndex) {
            return opt === candidateValue;
          }
          if (selection[idx]) {
            return opt === selection[idx];
          }
          return true;
        });
      });
    }
    function updateAllOptions() {
    let selection = getSelection();
    optionBlocks.forEach((block) => {
        const optTitle = block.getAttribute("data-option-title")?.trim().toLowerCase();
        if (!FILTER_OPTIONS.includes(optTitle)) {
        return;
        }
        const optionIndex = parseInt(block.getAttribute("data-option-block"), 10) - 1;
        const selectEl = block.querySelector("select.new-product-option-input");
        const radioEls = block.querySelectorAll('input.new-product-option-input[type="radio"]');
        let anyVisible = false;
        let autoSelectedElement = null;
        if (selectEl) {
        const opts = Array.from(selectEl.options);
        opts.forEach((opt) => {
            const val = opt.value;
            const valid = isValid(optionIndex, val, selection);
            opt.classList.toggle("new-metal-grade-hide", !valid);
            if (valid) anyVisible = true;
        });
        let currentValue = selectEl.value;
        let currentValid = isValid(optionIndex, currentValue, selection);
        if (!currentValid && anyVisible) {
            const firstValid = opts.find(
            (o) => !o.classList.contains("new-metal-grade-hide")
            );
            if (firstValid) {
            selectEl.value = firstValid.value;
            selection[optionIndex] = firstValid.value;
            autoSelectedElement = selectEl;
            }
        } else if (currentValid) {
            selection[optionIndex] = currentValue;
        }
        }
        if (radioEls.length) {
        radioEls.forEach((radio) => {
            const val = radio.value;
            const valid = isValid(optionIndex, val, selection);
            radio.classList.toggle("new-metal-grade-hide", !valid);
            radio.disabled = !valid;
            const label = radio.nextElementSibling;
            if (label) label.classList.toggle("new-metal-grade-hide", !valid);
            if (valid) anyVisible = true;
        });
        const checkedRadio = Array.from(radioEls).find(
            (r) => r.checked && !r.classList.contains("new-metal-grade-hide")
        );
        let currentValid = checkedRadio
            ? isValid(optionIndex, checkedRadio.value, selection)
            : false;
        if (!currentValid && anyVisible) {
            const firstValidRadio = Array.from(radioEls).find(
            (r) => !r.classList.contains("new-metal-grade-hide")
            );
            if (firstValidRadio) {
            firstValidRadio.checked = true;
            selection[optionIndex] = firstValidRadio.value;
            autoSelectedElement = firstValidRadio;
            }
        } else if (checkedRadio && currentValid) {
            selection[optionIndex] = checkedRadio.value;
        }
        }
        let validSelectCount = 0;
        if (selectEl) {
        validSelectCount = Array.from(selectEl.options).filter(
            (o) => !o.classList.contains("new-metal-grade-hide")
        ).length;
        }

        let validRadioCount = 0;
        if (radioEls.length) {
        validRadioCount = Array.from(radioEls).filter(
            (r) => !r.classList.contains("new-metal-grade-hide")
        ).length;
        }

        const blockHasAnyValid =
        validSelectCount > 0 || validRadioCount > 0;

        const titleEl = block.previousElementSibling;

        if (!blockHasAnyValid) {
        block.classList.add("new-metal-grade-hide");

        if (titleEl && titleEl.classList.contains("new-product-options-title")) {
            titleEl.classList.add("new-metal-grade-hide");
        }
        } else {
        block.classList.remove("new-metal-grade-hide");

        if (titleEl && titleEl.classList.contains("new-product-options-title")) {
            titleEl.classList.remove("new-metal-grade-hide");
        }
        }
        if (autoSelectedElement) {
        autoSelectedElement.dispatchEvent(
            new Event("change", { bubbles: true })
        );
        }
    });
    return selection;
    }
    wrapper
      .querySelectorAll(".new-product-option-input")
      .forEach((input) => {
        input.addEventListener("change", () => {
          updateAllOptions();
        });
      });
    updateAllOptions();
  });
});

$(document).on("change", ".new-option-swatch-inp", function(){
    // let val = "";
    $(".new-tissot-smooth ,.new-tissot-fluted").removeClass("active");
    if($(this).is(":checked")){
        $(`.new-tissot-wrapper.active .new-tissot-fluted`).addClass("active");
    }
    else{
        $(`.new-tissot-wrapper.active .new-tissot-smooth`).addClass("active");
    }
    // $(".new-product-options-wrapper.active .new-product-options.new-hide-option-for-prod select.new-product-option-input")[0].value = val;
    // $(".new-product-options-wrapper.active .new-product-options.new-hide-option-for-prod .new-product-option-input")[0].dispatchEvent(new Event("change", { bubbles: true }));
})
